import { render, staticRenderFns } from "./OASystem.vue?vue&type=template&id=1e5e23fc&scoped=true&"
import script from "./OASystem.vue?vue&type=script&lang=js&"
export * from "./OASystem.vue?vue&type=script&lang=js&"
import style0 from "./OASystem.vue?vue&type=style&index=0&id=1e5e23fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e23fc",
  null
  
)

export default component.exports